// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiPaymentDetails {
    'payment_address': string;
    'has_designated_payee': boolean;
    'designated_payee_name': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "payment_address",
            "baseName": "payment_address",
            "type": "string",
            "format": ""
        },
        {
            "name": "has_designated_payee",
            "baseName": "has_designated_payee",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "designated_payee_name",
            "baseName": "designated_payee_name",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiPaymentDetails.attributeTypeMap;
    }

    public constructor() {
    }
}
